var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62207 0.181152C8.86348 -0.0602557 9.25566 -0.0602557 9.49707 0.181152C9.73813 0.422541 9.73825 0.813858 9.49707 1.05518L5.28027 5.27002C5.27868 5.27165 5.27798 5.27427 5.27637 5.27588C5.1555 5.39671 4.99727 5.45671 4.83887 5.45654C4.6806 5.45659 4.52212 5.39663 4.40137 5.27588C4.39957 5.27408 4.39825 5.27183 4.39648 5.27002L0.181641 1.05518C-0.0597469 0.813788 -0.0597058 0.422565 0.181641 0.181152C0.423049 -0.0602557 0.814256 -0.0602557 1.05566 0.181152L4.83887 3.96436L8.62207 0.181152Z",
    fill: "#615E83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.fdd6d67c71e6d4f00decba741aea4054.svg";
export { ForwardRef as ReactComponent };